import { useGetBalance } from '@/hooks/disbursement/useGetBalance';
import { formatDollarAmount } from '@/utils/amounts';
import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { BalanceUi } from './BalanceUi';

export function useBalanceViewController() {
  const [uiState, setUiState] = useImmer<BalanceUi>({
    balanceAmount: '',
  });
  const getBalanceHook = useGetBalance();

  useEffect(() => {
    const amount = getBalanceHook.data?.available;
    if (amount === undefined) return;
    setUiState((draft) => {
      draft.balanceAmount = `$${formatDollarAmount(amount)}`;
    });
  }, [getBalanceHook.data]);

  return {
    uiState,
  };
}
